<template>
    <Dialog 
      :visible="visible" 
      :header="editMode ? 'Modifier le fournisseur' : 'Ajouter un fournisseur'" 
      :style="{ width: '850px' }" 
      :modal="true" 
      class="p-fluid"
      @update:visible="$emit('update:visible', $event)"
    >
      <form @submit.prevent="handleSubmit">
        <div class="grid formgrid p-fluid">
          <div class="field col-12 md:col-6">
            <label for="name">Nom du fournisseur</label>
            <InputText 
              id="name" 
              v-model="formData.name" 
              :class="{'p-invalid': submitted && !formData.name}" 
              autofocus 
              required 
            />
            <small v-if="submitted && !formData.name" class="p-error">Le nom est requis.</small>
          </div>
          
          <div class="field col-12 md:col-3">
            <label for="elec">ELEC</label>
            <div class="flex align-items-center mt-2">
              <InputSwitch id="elec" v-model="formData.elec" />
            </div>
          </div>
          
          <div class="field col-12 md:col-3">
            <label for="gaz">GAZ</label>
            <div class="flex align-items-center mt-2">
              <InputSwitch id="gaz" v-model="formData.gaz" />
            </div>
          </div>
          
          <div class="field col-12 md:col-6">
            <label for="segment_elec">SEGMENT ELEC</label>
            <InputText id="segment_elec" v-model="formData.segment_elec" />
          </div>
          
          <div class="field col-12 md:col-6">
            <label for="segment_gaz">SEGMENT GAZ</label>
            <InputText id="segment_gaz" v-model="formData.segment_gaz" />
          </div>
          
          <div class="field col-12 md:col-6">
            <label for="marge">MARGE</label>
            <InputText id="marge" v-model="formData.marge" />
          </div>
          
          <div class="field col-12 md:col-6">
            <label for="restriction">Restriction</label>
            <InputText id="restriction" v-model="formData.restriction" />
          </div>
          
          <div class="field col-12 md:col-6">
            <label for="credit_note">CREDIT NOTE</label>
            <InputText id="credit_note" v-model="formData.credit_note" />
          </div>
          
          <div class="field col-12 md:col-6">
            <label for="turpe">TURPE</label>
            <InputText id="turpe" v-model="formData.turpe" />
          </div>
          
          <div class="field col-12 md:col-6">
            <label for="capa">CAPA</label>
            <InputText id="capa" v-model="formData.capa" />
          </div>
          
          <div class="field col-12 md:col-6">
            <label for="cee">CEE</label>
            <InputText id="cee" v-model="formData.cee" />
          </div>
          
          <div class="field col-12 md:col-6">
            <label for="energie_verte">Energie VERTE</label>
            <InputText id="energie_verte" v-model="formData.energie_verte" />
          </div>
          
          <div class="field col-12">
            <label for="commentaire">Commentaire</label>
            <InputText id="commentaire" v-model="formData.commentaire" />
          </div>
        </div>
      </form>
      
      <template #footer>
        <Button label="Annuler" icon="pi pi-times" outlined @click="cancel" class="p-button-text" />
        <Button label="Enregistrer" icon="pi pi-check" @click="handleSubmit" />
      </template>
    </Dialog>
  </template>
  
  <script setup>
  import { ref, reactive, watch, defineProps, defineEmits } from 'vue'
  
  const props = defineProps({
    visible: {
      type: Boolean,
      required: true
    },
    supplier: {
      type: Object,
      required: true
    },
    editMode: {
      type: Boolean,
      default: false
    }
  })
  
  const emit = defineEmits(['update:visible', 'save', 'cancel'])
  
  // Form data
  const formData = reactive({
    id: null,
    name: '',
    active: true,
    elec: false,
    gaz: false,
    segment_elec: '',
    segment_gaz: '',
    marge: '',
    restriction: '',
    credit_note: '',
    turpe: '',
    capa: '',
    cee: '',
    energie_verte: '',
    commentaire: ''
  })
  
  // Form state
  const submitted = ref(false)
  
  // Watch for changes in supplier data from parent
  watch(() => props.supplier, (newSupplier) => {
    if (newSupplier) {
      // Copy all properties from supplier to formData
      Object.keys(formData).forEach(key => {
        if (key in newSupplier) {
          formData[key] = newSupplier[key]
        }
      })
    }
  }, { deep: true, immediate: true })
  
  // Submit form
  const handleSubmit = () => {
    submitted.value = true
    
    if (formData.name.trim()) {
      emit('save', { ...formData })
    }
  }
  
  // Cancel form
  const cancel = () => {
    submitted.value = false
    emit('cancel')
  }
  </script>
  
  <style lang="scss" scoped>
  // No additional styles needed
  </style>